import React, { Fragment, useState, useEffect } from "react";
import { Card, CustomInput, Badge } from "reactstrap";
import { NavLink } from "react-router-dom";
import classnames from "classnames";
import { Colxx } from "../../../../../../components/common/CustomBootstrap";
import no_image from '../../../../../../assets/no_image.png';

const ServicesThumbListView = ({ service, isSelect, onCheckItem, allAddonCategoryData }) => {
    const [categoryColor, setCategoryColor] = useState([]);
    function generateRandomColor() {
        var arr = [
            'primary',
            'secondary',
            'info',
            'success',
            'warning',
            'danger',
            'light',
            'dark',
        ];
        return arr[Math.floor(Math.random() * arr.length)];
    }
    function generateRandomColorCategory(category) {
        var arr = [
            'primary',
            'secondary',
            'info',
            'success',
            'warning',
            'danger',
            'light',
            'dark',
            'orange',
            'blue',
            'violet',
            'light-red',
            'sky-blue',
            'outline-primary',
            'outline-secondary',
            'outline-info',
            'outline-success',
            'outline-warning',
            'outline-danger',
            'outline-light',
            'outline-dark',
        ];
        return arr[category];
    }
    useEffect(() => {
        var cate = [];
        allAddonCategoryData.map((item, i) => {
            cate.push({
                label: item.id,
                color: generateRandomColorCategory(i)
            })
        });
        setCategoryColor(cate);
    }, [service, allAddonCategoryData]);

    return (
        <Colxx xxs="12" key={service.id} className="mb-3">
            <Card
                onClick={event => onCheckItem(event, service.id)}
                className={classnames("d-flex flex-row", {
                    active: isSelect
                })}
            >
                <div className="custom-control custom-checkbox pl-1 align-self-center">
                    <CustomInput
                        className="item-check mb-0"
                        type="checkbox"
                        id={`check_${service.id}`}
                        checked={isSelect}
                        onChange={() => { }}
                        label=""
                    />
                </div>
                <img
                    alt={service.title}
                    src={
                        service.imageLink
                            ? service.imageLink
                            : no_image
                    }
                    className="list-thumbnail responsive border-0"
                />

                <div className="pl-2 d-flex flex-grow-1 min-width-zero">
                    <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                        <p className="w-30 w-sm-100 list-item-heading mb-1 mr-1">
                            {service.title}
                        </p>
                        {/* <p className="mb-1 text-muted text-small w-15 w-sm-100 mr-1">
                            {service.type}
                        </p> */}

                        {/* <p className="mb-1 text-muted text-small w-15 w-sm-100 mr-1">
                            {service.displayText}
                        </p>
                        <p className="mb-1 text-muted text-small w-15 w-sm-100 mr-1">
                            {service.conditions}
                        </p> */}
                        {/* <p className="mb-1 text-muted text-small w-15 w-sm-100 mr-1">
                            {service.currency} {service.priceRangeStart} - {service.currency} {service.priceRangeEnd}
                        </p> */}
                        <p className="mb-1 text-small w-30 w-sm-100 mr-1">
                            {service.categoryId !== undefined && service.categoryId !== null &&
                                service.categoryId.length > 0 && service.categoryId.map((cat) => (
                                    <Fragment>
                                        <Badge
                                            color={categoryColor.length > 0 &&
                                                categoryColor.filter(i => i.label === cat.id).map((e) => e.color)} className="mt-1 mr-1">
                                            {allAddonCategoryData.filter(j => j.id === cat.id).map(elem => elem.title)}
                                        </Badge>
                                    </Fragment>
                                ))}
                        </p>
                    </div>
                </div>
            </Card>
        </Colxx>
    )
}
export default ServicesThumbListView;